module.exports = __webpack_public_path__ + "img/avatar_11.cae686a8.svg";